import type { SimpleGit } from 'simple-git';
import { tryConfigGet } from './git-config.js';

export type BranchRemoteConfig = {
  branch: string | null;
  remote: string;
  merge: string | null;
};

export async function readBranchRemoteConfig(g: SimpleGit): Promise<BranchRemoteConfig> {
  const branch = (await g.raw(['rev-parse', '--abbrev-ref', 'HEAD'])).trim();
  if (!branch || branch === 'HEAD') {
    return { branch: null, remote: 'origin', merge: null };
  }
  const [remote, merge] = await Promise.all([
    tryConfigGet(g, `branch.${branch}.remote`),
    tryConfigGet(g, `branch.${branch}.merge`),
  ]);
  return { branch, remote: remote ?? 'origin', merge };
}

export function trackingRefCandidates(config: BranchRemoteConfig): string[] {
  const candidates = ['HEAD@{upstream}', '@{u}'];
  if (!config.branch) return candidates;
  if (config.merge) {
    candidates.push(
      `refs/remotes/${config.remote}/${config.merge.replace(/^refs\/heads\//, '')}`,
    );
  }
  candidates.push(`refs/remotes/${config.remote}/${config.branch}`);
  return candidates;
}
